import React from "react";
import ColorPicker from "react-gcolor-picker";

import {
  MessageBoxWidgetDto,
  ProgressBarWidgetDto,
  QuantityButtonsWidgetDto,
  ResolvedQuantityButtonsDeviceConfig,
} from "@intelligems/ig-types";
import { Popover, useTheme } from "@mui/material";

import { getColorPickerValue } from "../utils/colorUpdates";

interface ColorPickerSectionProps {
  colorPickerState: {
    open: boolean;
    anchorEl: HTMLElement | null;
    activeField: string | null;
  };
  onClose: () => void;
  onColorChange: (field: string, color: string) => void;
  styleConfig: ResolvedQuantityButtonsDeviceConfig;
  widget: ProgressBarWidgetDto | QuantityButtonsWidgetDto | MessageBoxWidgetDto;
}

export const ColorPickerSection = ({
  colorPickerState,
  onClose,
  onColorChange,
  styleConfig,
  widget,
}: ColorPickerSectionProps) => {
  const theme = useTheme();

  return (
    <Popover
      open={colorPickerState.open}
      anchorEl={colorPickerState.anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    >
      {colorPickerState.activeField && (
        <ColorPicker
          format="hex"
          solid
          defaultColors={[]}
          value={getColorPickerValue(
            colorPickerState.activeField,
            styleConfig,
            widget,
            theme.palette.common.black,
            theme
          )}
          onChange={(color) =>
            colorPickerState.activeField &&
            onColorChange(colorPickerState.activeField, color)
          }
        />
      )}
    </Popover>
  );
};
